// 거래 장부의 단일 writer 권한. 비동기 브라우저 콜백은 상태 신호만 전달한다.
export type CommerceLockState = 'held' | 'waiting' | 'unavailable';
export interface CommerceLockProvider {
  acquire(changed: (state: CommerceLockState) => void): () => void;
}
export const COMMERCE_LOCK = 'dungeonhero.commerce';

export function browserCommerceLock(): CommerceLockProvider | null {
  if (typeof navigator === 'undefined' || !navigator.locks) return null;
  const locks = navigator.locks;
  return {
    acquire(changed) {
      const abort = new AbortController();
      let release: (() => void) | undefined;
      const hold = (): Promise<void> => {
        changed('held');
        return new Promise<void>(resolve => { release = resolve; });
      };
      const failed = (): void => { if (!abort.signal.aborted) changed('unavailable'); };
      void locks.request(COMMERCE_LOCK, { ifAvailable: true }, lock => {
        if (abort.signal.aborted) return;
        if (lock) return hold();
        changed('waiting');
        void locks.request(COMMERCE_LOCK, { signal: abort.signal }, () => {
          if (!abort.signal.aborted) return hold();
        }).catch(failed);
      }).catch(failed);
      return () => { abort.abort(); release?.(); };
    },
  };
}
